export enum ReservationOrDowntimeEnum {
  All = 0,
  ReservationsOnly = 1,
  DownTimeOnly = 2,
}
